import styled from 'styled-components'

export const CarouselItemStyled = styled.div<{ $isActive: boolean }>`
  grid-area: 1 / 1;
  width: 100%;
  opacity: ${(props) => (props.$isActive ? 1 : 0)};
  transition: opacity 300ms ease;
  pointer-events: ${(props) => (props.$isActive ? 'auto' : 'none')};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
